import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiChopin, API_CHOPIN } from '../config/index';
import { Observable } from 'rxjs';
import { CreatePlaylist, Pagination, Playlist, UpdatePlaylist, Performance, PaginationRequestParams } from '@shared/interfaces';
import { map } from 'rxjs/operators';

@Injectable()
export class PlaylistsService {
  constructor(
    @Inject(API_CHOPIN) private api: ApiChopin,
    private http: HttpClient
  ) {}

  getAll(): Observable<Playlist[]> {
    return this.http.get<Pagination<Playlist>>(this.api.PLAYLISTS())
      .pipe(map(item => item.items));
  }

  create(data: CreatePlaylist): Observable<Playlist> {
    return this.http.post<Playlist>(this.api.PLAYLISTS(), data);
  }

  get(id: number): Observable<Playlist> {
    return this.http.get<Playlist>(this.api.PLAYLISTS(id));
  }

  edit(id: number, data: UpdatePlaylist): Observable<Playlist> {
    return this.http.put<Playlist>(this.api.PLAYLISTS(id), data);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(this.api.PLAYLISTS(id));
  }

  getPerformances(playlistId: number, params: PaginationRequestParams): Observable<Pagination<Performance>> {
    return this.http.get<Pagination<Performance>>(this.api.PLAYLIST_PERFORMANCES(playlistId), { params: params as any });
  }

  addPerformances(id: number, performances: number[]): Observable<Playlist> {
    return this.http.post<Playlist>(this.api.PLAYLIST_ADD_PERFORMANCES(id), { performances });
  }

  removePerformances(id: number, performances: number[]): Observable<Playlist> {
    return this.http.post<Playlist>(this.api.PLAYLIST_DELETE_PERFORMANCES(id), { performances });
  }

}
